import { Routes } from '@angular/router';
import { uaaModuleRoutes } from './utilities-apps/uaa/uaa-routing.module';

export const systemUtilitiesRoutes: Routes = [
  { path: '', redirectTo: 'overview', pathMatch: 'full', data: { isNotAMenuItem: true } },
  {
    path: 'overview',
    loadComponent: () =>
      import('./utilities-apps/utilities-overview/utilities-overview').then(
        (m) => m.UtilitiesOverview,
      ),
    data: {
      name: 'Overview',
      icon: 'dashboard',
    },
  },
  {
    path: 'uaa',
    data: {
      name: 'User Management',
      icon: 'admin_panel_settings',
      iconType: 'MAT',
    },
    children: [...uaaModuleRoutes],
  },
  {
    path: 'designations',
    loadComponent: () =>
      import('../system-utilities/utilities-apps/designations/designations').then(
        (m) => m.Designations,
      ),
    data: {
      name: 'Designations',
      icon: 'badge',
    },
  },
  {
    path: 'organogram',
    data: {
      name: 'Organogram',
      icon: 'account_tree',
    },
    children: [
      { path: '', redirectTo: 'structure', pathMatch: 'full' },
      {
        path: 'structure',
        loadComponent: () =>
          import('../system-utilities/utilities-apps/institutions/organogram/organogram').then(
            (m) => m.Organogram,
          ),
        data: {
          name: 'Structure',
        },
      },

      
      {
        path: 'departments',
        loadComponent: () =>
          import('../system-utilities/utilities-apps/departments/departments').then(
            (m) => m.Departments,
          ),
        data: {
          name: 'Departments/Directorates',
        },
      },
      {
        path: 'departments/:id',
        loadComponent: () =>
          import('../system-utilities/utilities-apps/departments/view-department/view-department').then(
            (m) => m.ViewDepartment,
          ),
        data: {
          isNotAMenuItem: true,
          name: 'Department/Directorate Details',
        },
      },
      {
        path: 'sections',
        loadComponent: () =>
          import('../system-configs/config-apps/sectors-list/sectors-list').then((m) => m.SectorsList),
        data: {
          name: 'Sections',
        },
      },
      {
        path: 'units',
        loadComponent: () =>
          import('../system-configs/config-apps/units-list/units-list').then((m) => m.UnitsList),
        data: {
          name: 'Units',
        },
      },
    ],
  },
  {
    path: 'financial-year',
    loadComponent: () =>
      import('../system-utilities/utilities-apps/financial-year/financial-year').then(
        (m) => m.FinancialYear,
      ),
    data: {
      name: 'Financial year',
      icon: 'payments',
      hideRefresh: true,
      isNotAMenuItem: true,
    },
  },
  // {
  //   path: 'locations',
  //   loadComponent: () =>
  //     import('../system-utilities/utilities-apps/locations/locations').then((m) => m.Locations),
  //   data: {
  //     name: 'Locations',
  //     icon: 'place',
  //   },
  // },
];
